// extracted by mini-css-extract-plugin
export var backgroundImage = "FormCheckboxWithImageRight-module--backgroundImage--9facc";
export var btn = "FormCheckboxWithImageRight-module--btn--88d8a";
export var content = "FormCheckboxWithImageRight-module--content--5a18d";
export var form = "FormCheckboxWithImageRight-module--form--3d01d";
export var formSubmit = "FormCheckboxWithImageRight-module--formSubmit--a4a38";
export var formSubmitWrapper = "FormCheckboxWithImageRight-module--formSubmitWrapper--32bf0";
export var message = "FormCheckboxWithImageRight-module--message--0e6db";
export var option = "FormCheckboxWithImageRight-module--option--6e2e2";
export var optionWrapper = "FormCheckboxWithImageRight-module--optionWrapper--c4781";
export var personalInfo = "FormCheckboxWithImageRight-module--personalInfo--04a09";
export var submitBtn = "FormCheckboxWithImageRight-module--submitBtn--b5ddd";
export var submitSection = "FormCheckboxWithImageRight-module--submitSection--73aee";
export var validation = "FormCheckboxWithImageRight-module--validation--c0c3c";
export var wrapper = "FormCheckboxWithImageRight-module--wrapper--22a49";